import './OverlayLayer.scss';

interface OverlayLayerCallbacks {
    onClick: () => void;
}

const OverlayLayer = (layer_id: string, callbacks: OverlayLayerCallbacks, zIndex?: number) => {

    function makeid(length: number): string {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    layer_id = layer_id + '_' + makeid(37);

    if (!document.querySelector('.' + layer_id)) {
        // console.log('OverlayLayer, _createLayerIfNotExists, adding to DOM', layer_id);
        let root = document.createElement('div') as HTMLDivElement;
        root.classList.add('overlay-layer');
        root.classList.add(layer_id);
        root.style.zIndex = zIndex ? zIndex.toString() : '10000';
        root.addEventListener('click', (e) => {
            // console.log('OverlayLayer, _addListenersOnClick, e', e);
            callbacks.onClick();
        });
        document.querySelector('body')?.appendChild(root);
    } else {
        // console.log('OverlayLayer, _createLayerIfNotExists, already exists in DOM', layer_id);
        let oldroot = document.querySelector('.' + layer_id) as HTMLDivElement;
        let root = oldroot.cloneNode(true);
        if (oldroot.parentNode) {
            oldroot.parentNode.replaceChild(root, oldroot);
            root.addEventListener('click', (e) => {
                console.log('OverlayLayer, _addListenersOnClick, e', e);
                callbacks.onClick();
            });
        }
    }

    let root = document.querySelector('.' + layer_id) as HTMLDivElement;
    // if (document.querySelector('.' + layer_id)) {
    //     let el = document.querySelector('.' + layer_id);
    //     // Remove element from DOM
    //     el?.parentNode?.removeChild(el);
    // }

    // if (!document.querySelector('.' + layer_id)) {
    //     document.querySelector('body')?.appendChild(root);
    //     root.addEventListener('click', (e) => {
    //         callbacks.onClick();
    //     });
    // } else {
    //     throw new Error('OverlayLayer: layer with id ' + layer_id + ' already exists');
    // }

    const show = () => {
        // console.log('OverlayLayer, show', root);
        root.style.display = 'block';
    }

    const hide = () => {
        // console.log('OverlayLayer, hide', root);
        root.style.display = 'none';
    }

    // _addListenersOnClick();
    // _createLayerIfNotExists();

    return {
        root,
        show,
        hide
    }
}

export default OverlayLayer;
